module.exports = __webpack_public_path__ + "static/media/ambrosia.c30a67ea.jpg";